import script from "./List.vue?vue&type=script&setup=true&lang=js"
export * from "./List.vue?vue&type=script&setup=true&lang=js"

import "./List.vue?vue&type=style&index=0&id=164e263a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-164e263a"]])

export default __exports__